import { MainService } from 'src/app/Services/service.service';
import { AfterViewInit, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit{

  constructor(private service: MainService) {
    this.service.disclaimerIsReady = true;
  }

  ngOnInit() {

  }
}
